<template>
  <Article>
    <Heading as="h1">
      <!--  -->
      Disclaimer
    </Heading>
    <p>
      Use of this Web site, Blog and materials presented on it is subject to the
      following terms and conditions. By using this site, Blog and information
      contained herein, you agree to these terms and conditions and acknowledge
      reading them. This Web page includes disclaimers and disclosures
      concerning the following topics:
    </p>
    <ul>
      <li>No Attorney-Client Relationship or Legal Advice Intended</li>
      <li>License Status of Attorneys</li>
      <li>Links</li>
      <li>Privacy Statement</li>
      <li>No Warranty or Liability</li>
      <li>Our Copyright and Intellectual Property Rights</li>
      <li>Additional Disclosures and Information</li>
    </ul>
    <p>
      The term “Hobson Bernardino + Davis” in this Web site refers to Hobson
      Bernardino + Davis LLP, a California limited liability partnership, unless
      the context clearly indicates otherwise.
    </p>
    <p>
      <strong>
        All materials have been prepared for general information purposes only
        to permit you to learn more about our firm, our services and the
        experience of our attorneys. The information presented is not legal
        advice, is not to be acted on as such, may not be current and is subject
        to change without notice.
      </strong>
    </p>
    <Heading as="h2">
      <!--  -->
      No Attorney-Client Relationship or Legal Advice Intended
    </Heading>
    <p>
      Communication of information by, in, to or through this Web site and your
      receipt or use of it (1) is not provided in the course of and does not
      create or constitute an attorney-client relationship, (2) is not intended
      as a solicitation, (3) is not intended to convey or constitute legal
      advice, and (4) is not a substitute for obtaining legal advice from a
      qualified attorney. You should not act upon any such information without
      first seeking qualified professional counsel on your specific matter. The
      hiring of an attorney is an important decision that should not be based
      solely upon Web site communications or advertisements.
    </p>
    <p>
      You also should not rely upon the transmission of an e-mail message to an
      attorney through this Web site to create an attorney-client relationship.
      The transmission or exchange of information will not do so. Without an
      attorney-client relationship in the matter, we cannot assure you that your
      communications will be privileged or (unless we otherwise agree in a
      specific case) that we will treat them as such. Please do not send us any
      confidential or sensitive information until you speak with one of our
      attorneys and obtain prior written authorization to send that information
      to us.
    </p>
    <Heading as="h2">
      <!--  -->
      License Status of Attorneys
    </Heading>
    <p>
      Unless otherwise expressly specified, the attorneys listed in this Web
      site are not certified by, or certified as specialists or experts by, any
      professional or governmental agency or authority. Designations of our
      firm’s practice areas, or of expertise, practice concentrations or
      specializations of our attorneys are not intended (1) to suggest or
      represent the contrary, or (2) to suggest any professional or governmental
      standard by which such experience is measured, or (3) to denigrate other
      attorneys or firms in any way.
    </p>
    <p>
      This Web site is not intended as advertising or solicitation in any
      jurisdiction where the site would be so characterized and fail to comply
      with all applicable laws and ethical rules of that jurisdiction. Hobson
      Bernardino + Davis does not seek to represent anyone based solely upon a
      visit to this Web site or upon advertising, or where to do so would not
      comply with applicable local laws and rules.
    </p>
    <Heading as="h2">
      <!--  -->
      Links
    </Heading>
    <p>
      We may from time to time, directly or indirectly, provide links to or
      accept links from Web sites of other parties for convenience. We do not
      control or maintain the material presented by other persons in their Web
      sites. The inclusion of any link on our Web site does not imply any
      association or relationship between Hobson Bernardino + Davis and the
      person sponsoring the linked site and does not constitute or imply any
      endorsement, approval or sponsorship of the linked site by Hobson
      Bernardino + Davis, or the endorsement, approval or sponsorship of Hobson
      Bernardino + Davis by the sponsor of the linked site. The links do not
      imply legal authority to use any protected rights of others reflected in
      the links. We do not vouch for or assume any responsibility for the
      content, accuracy or completeness of material presented directly or
      indirectly in linked sites. If you use any of these links, you will leave
      our site.
    </p>
    <p>
      Without our prior written consent, you agree that you will not link
      material on our site to another Web site, or associate or frame material
      in this site with another Web page or materials of any other entity. If we
      permit such link, association or framing, you must agree to include or
      link with it this "Disclaimers and Terms of Use" Web page and to
      immediately terminate the link, association or framing at our request,
      unless we otherwise expressly agree.
    </p>
    <Heading as="h2">
      <!--  -->
      Privacy Statement
    </Heading>
    <p>
      If you visit our Web site simply to browse, we may collect general
      information about the way in which you use our site, including the time
      and duration of visit, type of Web browser used, the operating
      system/platform you are using, your IP address, the Web sites from which
      you linked to us, and your CPU speed. We also may note whether and how you
      use the site by recording site traffic patterns and “clickstreams.” We may
      use this information to identify levels and areas of interest in our firm
      and to improve and refine our site.
    </p>
    <p>
      If you choose to provide us with personal information about yourself,
      either through a form on our Web site or by sending us e-mail, we may
      collect and use that information to contact you or to send you additional
      information. We do not sell or lease any personally identifiable
      information provided by our visitors to any unrelated third parties, but
      we may share it with related entities or with unrelated third parties in
      connection with our own marketing activities or the maintenance and
      operation of our site, or as may be legally required. (Please also
      remember the additional warnings under “Disclaimers and Terms of Use” not
      to send confidential or sensitive information to us through this site.)
    </p>
    <p>
      Although we use security that we believe to be appropriate to protect the
      limited personal identifying information disclosed to us on this Web site,
      we do not guarantee that our security precautions will protect against—and
      we expressly disclaim any liability for—any loss, misuse, or alteration of
      your information or from your access to or use of our information.
    </p>
    <p>
      We may use “cookie” technology. A cookie is a small amount of data sent by
      our Web site and stored on your computer’s hard drive that our site can
      read and which helps us keep track of how you use our site. Many Web
      browsers automatically accept cookies by default, but contain an option
      for you to turn off the cookie acceptance if you prefer.
    </p>
    <p>
      If you do not want us to further use information previously given by you
      on or through this Web site to contact you, or if you wish to correct such
      information, please contact info@hbdlegal.com.
    </p>
    <Heading as="h2">
      <!--  -->
      No Warranty or Liability
    </Heading>
    <p>
      <strong>
        The information presented on this Web site is provided “as is” without
        representation or warranty of any kind as to suitability, reliability,
        applicability, merchantability, fitness, noninfringement, result,
        outcome or any other matter. We do not represent or warrant that such
        information is or will be always up-to-date, complete, or accurate. Any
        representation or warranty that might be otherwise implied is expressly
        disclaimed.
      </strong>
    </p>
    <p>
      <strong>
        You agree that we are not liable to you or others, in any way or for any
        damages of any kind or under any theory, arising from this site, or your
        access to or use of or reliance on the information in or through this
        site, including but not limited to liability or damages under contract
        or tort theories or any damages caused by viruses contained within
        electronic files of this site or any linked site, regardless of prior
        notice to us.
      </strong>
    </p>
    <Heading as="h2">
      <!--  -->
      Hobson Bernardino + Davis Copyright and Intellectual Property Rights
    </Heading>
    <p>
      Unless otherwise noted, all materials, including but not limited to
      images, illustrations, designs, icons, photographs, video clips, software,
      and written and other materials that are part of this Web site or any
      other Hobson Bernardino + Davis Web site are protected under copyright
      laws and are the trademarks, trade dress and/or other intellectual
      property owned, controlled and/or licensed by Hobson Bernardino + Davis.
      You may download and view material on this Web site for your personal,
      temporary, non-commercial viewing only. No part of these materials may
      otherwise be copied, reproduced, stored, republished, uploaded, posted,
      transmitted, or distributed in any form or by any means, electronic or
      mechanical, now known or hereafter invented, without the prior written
      permission from Hobson Bernardino + Davis.
    </p>
    <Heading as="h2">
      <!--  -->
      Additional Disclosures and Information
    </Heading>
    <p>
      Practice and other descriptions, including attorney biographies, on this
      Web site may include descriptions of successful client representations,
      strategies or outcomes in matters, including transactional and adversarial
      proceedings. The results portrayed were dependent on the facts of the
      particular matters described, among other variables. Results will differ
      if based on different facts. We intend no assurance and make no guarantee
      or prediction that we will be successful in new matters, even if they
      involve similar facts and circumstances, or that we are successful in all
      matters. Results in any matter are not necessarily indicative of or
      similar to results in other matters.
    </p>
    <p>
      Any disputes concerning this Web site and the information in or use of it
      shall be governed by California law (without regard to conflicts of law
      principles), and any proceeding which may arise out of or in connection
      with this Web site shall be brought solely in a court in Los Angeles,
      California.
    </p>
  </Article>
</template>

<script setup>
defineOptions({ name: "ViewDisclaimer" });
import Article from "../components/Article.vue";
import Heading from "../components/Heading.vue";
</script>
